'use strict'

module.exports = {
  NODE_ENV: '"ca"',
  APP_BASEURL: '"https://hermes-ca.protopia.co/"',
  API_BASEURL: '"https://api-ca.protopia.co/"',
  APP_REDIRECT_URL: '"https://protopia.co/maintenance"',
  AUTH0_DOMAIN: '"protopia.auth0.com"',
  AUTH0_CLIENT: '"pCVqVPDAovZJCwqIWrvJRBgRK6JySwia"',
  AUTH0_CALLBACK: '"https://hermes-ca.protopia.co/callback"',
  NLP_API_KEY: '"AIzaSyDs_B35xkjF54wCFdaYpL-V-cuVpFtKPTc"',
  LOGO_URL: '"https://storage.googleapis.com/protopia/logos/logo_protopia_xs.png"',
  LINKEDIN_CLIENT_ID: '"86bm0xpurfqdqb"',
  LINKEDIN_CLIENT_SECRET: '"i0MwVy2mRbdJk5E7"',
  LINKEDIN_REDIRECT_URI: '"https://hermes-ca.protopia.co/thank-you"',
  LINKEDIN_STATE_KEY: '"PROTOPIA"',
  DEFAULT_EMAIL: '"team@protopia.co"',
  RANDOM_INTEREST_COUNT: 15,
  ADDITIONAL_PARAM_FRIENDLY_COUNT: 12,
  APP_REDIRECT_TIME: 10000,
  CAPTCHA_SITEKEY: '6Le09i0tAAAAABx5hlfHc6W0Z0OklaAl9cUFl4I3',
  VUE_APP_PROCESS_DASHBOARD_URL: '"https://hermes-ca.protopia.co/process-dashboard"',

  // Public base of the recruiting wizard.
  RECRUITING_BASEURL: '"https://opportunities.protopia.co"'
}



//////////////////
// WEBPACK FOOTER
// ./config/ca.env.js
// module id = BJeB
// module chunks = 1